/**
 * Checks the initial scrollLeft of the browser in RTL direction
 *
 * @returns - rtlScrollType -> 'negative','positive' or 'reversed'
 */
const scrollLeftDirection = () => {
    /* Append a RTL scrollable 1px square containing a 2px-wide child and check
      the initial scrollLeft and whether it's possible to set a negative one.
    */
    document.body.insertAdjacentHTML('beforeend', "<div class='overflow-carousel__browser-direction'><div class='overflow-carousel__browser-item'></div></div>");
    const scroller = document.body.lastElementChild;
    const initially_positive = scroller.scrollLeft > 0;
    scroller.scrollLeft = -1;
    const has_negative = scroller.scrollLeft < 0;
    const result = {
        decreasing: has_negative || initially_positive,
        nonpositive: has_negative,
    };
    document.body.removeChild(scroller);
    if (result.decreasing && result.nonpositive) {
        return 'negative';
    }
    else if (result.decreasing && !result.nonpositive) {
        return 'reversed';
    }
    return 'positive';
};
/**
 *
 * @param {*} rtl - RTL direction boolean
 * @param {*} rtlScrollType - RTL type retrived from scrollLeftDirection
 * @param {*} target - item that Carousel scrolls to.
 * @param {*} container - Carousel scrolling container
 * @returns - next scrollLeft position
 */
const scrollLeftNextCustom = (rtl, rtlScrollType, target, container) => {
    if (!rtl)
        return target.offsetLeft;
    switch (rtlScrollType) {
        case 'negative':
            return (target.offsetLeft -
                container.offsetWidth +
                target.getBoundingClientRect().width);
        case 'reversed':
            return (container.scrollWidth -
                2 * container.offsetWidth +
                target.offsetLeft +
                target.getBoundingClientRect().width);
        default:
            return (container.offsetWidth -
                target.offsetLeft -
                target.getBoundingClientRect().width);
    }
};
/**
 *
 * @param {*} rtl - RTL direction boolean
 * @param {*} rtlScrollType - RTL type retrived from scrollLeftDirection
 * @param {*} target - item that Carousel scrolls to.
 * @param {*} container - Carousel scrolling container
 * @returns - next scrollLeft position
 */
const scrollLeftPrevCustom = (rtl, rtlScrollType, target, container) => {
    if (!rtl)
        return (target.offsetLeft +
            target.getBoundingClientRect().width -
            container.offsetWidth);
    switch (rtlScrollType) {
        case 'negative':
            return target.offsetLeft;
        case 'reversed':
            return container.scrollWidth - container.offsetWidth + target.offsetLeft;
        default:
            return -target.offsetLeft;
    }
};
export { scrollLeftDirection, scrollLeftNextCustom, scrollLeftPrevCustom };
